import React, { useState, useContext } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import ISagaImage from "../../assests/isaga-2.png";
import { Context as AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { TextField, Alert, AlertTitle, InputAdornment, IconButton } from "@mui/material";
import { setUserGlobal, setPasswordGlobal } from "../../utils/constantes";
import { Person, Visibility, VisibilityOff  } from "@mui/icons-material";
import "./Login.css";
import Context from "../../context/Context";

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showAlertError, setShowAlertError] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  let navigate = useNavigate();

  const { handleLogin } = useContext(AuthContext);
  const { setSelectedValueSector } = useContext(Context);

  const loginButton = async () => {
    setUserGlobal(user);
    setPasswordGlobal(password);

    setLoading(true);
    var ret = await handleLogin();

    const userAuth = JSON.parse(localStorage.getItem('user') as string);

    if (userAuth?.sector)
      setSelectedValueSector({
        stR_description: userAuth.sector.stR_description,
        stR_SAPCode: userAuth.sector.stR_SAPCode
      })

    if (ret) {
      setLoading(false);
      navigate("Dashboard");
    } else {
      setTimeout(() => {
        setLoading(false);
        setShowAlertError(true);
      }, 1000);
    }
  };

  const handleClickShowPassword = () => {
    setViewPassword(!viewPassword);
  }

  return (
    <div className="body">
      <div className="login-body">

        <div
          className="container p-4 login-data"
          style={{ display: "flex", flexDirection: "column", gap: 10 }}
        >
          <img src={ISagaImage} alt="logo-iSaga" className="mb-2" />

          <TextField
            label="Login"
            defaultValue={user}
            onChange={(e) => setUser(e.target.value)}
            InputProps={{
              endAdornment: (
                <div className="px-2">
                  <InputAdornment position="end">
                    <Person />
                  </InputAdornment>
                </div>
              )
            }}
          />

          <TextField
            label="Senha"
            type={!viewPassword ? "password": "text"}
            defaultValue={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.keyCode === 13) loginButton();
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                  >
                    {viewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          {!!showAlertError && (
            <Alert severity="error" variant="filled">
              <AlertTitle>Login/Senha invalido</AlertTitle>
            </Alert>
          )}
          <center>
            <LoadingButton
              loading={loading}
              variant="contained"
              onClick={loginButton}
              className="loginButton"
            >
              Entrar
            </LoadingButton>
          </center>
        </div>
      </div>
    </div>
  );
};

export default Login;
